"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatDate = formatDate;
exports.formatRelativeDate = formatRelativeDate;
var INVALID_DATE = 'Invalid Date';
function formatDate(date) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  };
  var newDate = new Date(date);
  if (newDate.toString() === INVALID_DATE) {
    return '';
  }
  return newDate.toLocaleDateString('en-US', format);
}
function formatRelativeDate(date) {
  var newDate = new Date(date);
  if (newDate.toString() === INVALID_DATE) {
    return '';
  }
  var currentDate = new Date(Date.now());
  var diffTime = Math.abs(newDate - currentDate);
  var rtf1 = new Intl.RelativeTimeFormat('en', {
    numeric: 'auto',
    style: 'long'
  });
  var minute = 1000 * 60;
  var humanTime;
  var unit;

  // If there are years
  if (diffTime > minute * 60 * 24 * 365) {
    humanTime = Math.floor(diffTime / (minute * 60 * 24 * 365));
    unit = 'year';
  }

  // If there are months
  else if (diffTime > minute * 60 * 24 * 30) {
    humanTime = Math.floor(diffTime / (minute * 60 * 24 * 30));
    unit = 'months';
  }

  // If there are weeks
  else if (diffTime > minute * 60 * 24 * 7) {
    humanTime = Math.floor(diffTime / (minute * 60 * 24 * 7));
    unit = 'week';
  }

  // If there are days
  else if (diffTime > minute * 60 * 24) {
    humanTime = Math.floor(diffTime / (minute * 60 * 24));
    unit = 'day';
  }

  // If there are hours
  else if (diffTime > minute * 60) {
    humanTime = Math.floor(diffTime / (minute * 60));
    unit = 'hour';
  }

  // If there are minutes
  else if (diffTime > minute) {
    humanTime = Math.floor(diffTime / minute);
    unit = 'minute';
  }

  // Otherwise, use seconds
  else {
    humanTime = Math.floor(diffTime / 1000);
    unit = 'second';
    if (humanTime < 10) {
      return 'now';
    }
  }
  return rtf1.format(-humanTime, unit);
}
//# sourceMappingURL=date.js.map